// DOSYA YOLU: src/components/Header.js

import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { auth } from '../firebase';
import { useAuthState } from 'react-firebase-hooks/auth';
import { signOut } from 'firebase/auth';
// 🔥 Font Context Hook'u import edildi
import { useFont } from '../context/FontContext'; 

// Stil tanımı (sadece butonlar için)
const fontControlStyles = {
    button: {
        background: 'none',
        border: '1px solid #ddd',
        color: '#333',
        padding: '5px 10px',
        margin: '0 5px',
        borderRadius: '5px',
        cursor: 'pointer',
        fontSize: '16px',
        fontWeight: 'bold',
        transition: 'background-color 0.2s',
    },
    label: {
        fontSize: '14px',
        color: '#666',
        marginRight: '10px',
        marginLeft: '10px'
    }
};


export default function Header() {
    const [user, loading] = useAuthState(auth);
    const navigate = useNavigate();

    // 🔥 useFont hook'u ile fonksiyonları ve mevcut boyutu al
    const { increaseFontSize, decreaseFontSize, fontSize } = useFont(); 

    // Çıkış yapma (Logout) işlemi
    const handleLogout = async () => {
        try {
            await signOut(auth);
            navigate('/login'); 
        } catch (error) {
            console.error("Çıkış yapma hatası:", error);
            alert("Çıkış yapılırken bir hata oluştu.");
        }
    };

    if (loading) {
        return null; 
    }

    return (
        <header className="app-header">
            <div className="header-container">
                {/* Sol Taraf: Uygulama Adı/Logosu */}
                <Link to="/" className="app-logo">
                    🚀 FutureHelper
                </Link>

                {/* Sağ Taraf: Navigasyon ve Kullanıcı Aksiyonları */}
                <nav className="header-nav" role="navigation">
                    {user && (
                        // 🔥 Kullanıcı giriş yapmışsa font kontrol butonlarını göster
                        <div className="font-controls" style={{ display: 'flex', alignItems: 'center' }}>
                            <span style={fontControlStyles.label}>Yazı Boyutu:</span>
                            <button 
                                onClick={decreaseFontSize} 
                                style={fontControlStyles.button}
                                aria-label="Yazı Boyutunu Küçült" // A11y
                                disabled={fontSize <= 14}
                            >
                                A-
                            </button>
                            <button 
                                onClick={increaseFontSize} 
                                style={fontControlStyles.button}
                                aria-label="Yazı Boyutunu Büyüt" // A11y
                                disabled={fontSize >= 24}
                            >
                                A+
                            </button>
                        </div>
                    )}
                    
                    {user ? (
                        // Kullanıcı Giriş Yapmışsa (Normal linkler)
                        <>
                            <Link to="/dashboard" className="nav-link">Gösterge Tablosu</Link>
                            <Link to="/ai-report" className="nav-link">Genel Analiz</Link>
                            <button onClick={handleLogout} className="nav-button logout-btn">
                                Çıkış Yap
                            </button>
                        </>
                    ) : (
                        // Kullanıcı Giriş Yapmamışsa
                        <>
                            <Link to="/login" className="nav-button primary-btn">Giriş Yap</Link>
                            <Link to="/register" className="nav-button secondary-btn">Kayıt Ol</Link>
                        </>
                    )}
                </nav>
            </div>
        </header>
    );
}